import React from 'react'
import './index.css'
import Logo from './../Logo.jsx'
import { useSelector } from 'react-redux'
import MaskDropdown from './MaskDropdown.jsx'
import { NavLink } from 'react-router-dom'
import { useTheme } from '@mui/material/styles'
import { useMediaQuery } from '@mui/material'
import Popup from 'reactjs-popup'
import './MenuDropdown.css'
import { useSnackbar } from 'notistack'
import data from './../../assets/data.json'
import ProjectDropdown from './ProjectDropdown.jsx'
import useAuth from '../../hooks/useAuth'

function Header() {
	const loggedIn = useSelector((state) => state.user.value.loggedIn)
	const pex = useSelector((state) => state.user.value.pex)
	const theme = useTheme()
	const { enqueueSnackbar } = useSnackbar()
	const bigDisplay = useMediaQuery(theme.breakpoints.up('lg'))
	const [token, login, logout] = useAuth()

	function openNotification() {
		enqueueSnackbar(data.message.succLogout, { variant: 'info' })
	}

	return (
		<>
			<div id='header'>
				<Logo />
				<nav id='menu'>
					<ul>
						{bigDisplay ? (
							<>
								<li>
									<NavLink to='/' className='menuLink'>
										Home
									</NavLink>
								</li>

								<ProjectDropdown
									trigger={
										<li>
											<button className='menuLink'>Das Projekt</button>
										</li>
									}
									position='middle top'
									contentStyle={{
										marginTop: '65px',
										padding: '0px',
										border: 'none',
									}}
								/>

								{(pex.read_artist || pex.read_owner || pex.read_artwork) && (
									<MaskDropdown
										trigger={
											<li>
												<button className='menuLink'>Masken</button>
											</li>
										}
										position='middle top'
										contentStyle={{
											marginTop: '65px',
											padding: '0px',
											border: 'none',
										}}
									/>
								)}

								<li>
									<NavLink to='/contact' className='menuLink'>
										Kontakt
									</NavLink>
								</li>

								{pex.admin && (
									<li>
										<NavLink to='/adminpanel/' className='menuLink'>
											Admin Panel
										</NavLink>
									</li>
								)}

								<li>
									{loggedIn ? (
										<NavLink
											to='/login?logout'
											className='menuLink'
											onClick={(e) => {
												e.preventDefault()
												logout()
												openNotification()
											}}
										>
											Logout
										</NavLink>
									) : (
										<NavLink to='/login' className='menuLink'>
											Login
										</NavLink>
									)}
								</li>
							</>
						) : (
							<Popup
								trigger={
									<li style={{ marginLeft: '30px' }}>
										<a className='menuLink'>Menü</a>
									</li>
								}
								position='middle top'
								on='click'
								mouseLeaveDelay={300}
								mouseEnterDelay={0}
								closeOnDocumentClick={false}
								contentStyle={{
									marginTop: '70px',
									padding: '0px',
									border: 'none',
								}}
								arrow={false}
							>
								<ul id='menuDropdown'>
									<NavLink to='/'>Home</NavLink>
									<NavLink to='/about'>Das Projekt</NavLink>

									{(pex.read_artist || pex.read_owner || pex.read_artwork) && (
										<MaskDropdown
											trigger={<button> Masken </button>}
											position='right top'
											contentStyle={{ paddingRight: '0px', border: 'none' }}
										/>
									)}

									<NavLink to='/contact'>Kontakt</NavLink>

									{pex.admin && (
										<NavLink to='/adminpanel/'>Admin Panel</NavLink>
									)}

									{loggedIn ? (
										<NavLink
											to='/login?logout'
											onClick={(e) => {
												e.preventDefault()
												logout().then((result) => openNotification())
											}}
										>
											Logout
										</NavLink>
									) : (
										<NavLink to='/login'>Login</NavLink>
									)}
								</ul>
							</Popup>
						)}
					</ul>
				</nav>
			</div>
		</>
	)
}

export default Header
